import { useCreateNewScheduleMutation, useDeleteScheduleMutation, useUpdateScheduleMutation } from '../api/useSchedule';

export const useWorkspaceScheduleApi = () => {
  const { trigger: runCreateSchedule, ...createScheduleResponse } = useCreateNewScheduleMutation();
  const { trigger: runDeleteSchedule, ...deleteScheduleResponse } = useDeleteScheduleMutation();
  const { trigger: runUpdateSchedule, ...updateScheduleResponse } = useUpdateScheduleMutation();

  const createSchedule = async (
    workspaceID: number,
    updatedBy: string,
    cron: string,
    timezone: string,
    accountID: number,
    userID: number,
    applications: string[],
    description?: string,
  ) => {
    return await runCreateSchedule({
      workspaceID,
      updatedBy,
      cron,
      timezone,
      accountID,
      userID,
      applications,
      description,
    });
  };

  const deleteSchedule = async (workspaceID: number, updatedBy: string, accountID: number) => {
    return await runDeleteSchedule({
      workspaceID,
      updatedBy,
      accountID,
    });
  };

  const updateSchedule = async (
    workspaceID: number,
    updatedBy: string,
    cron: string,
    timezone: string,
    accountID: number,
    userID: number,
    applications: string[],
  ) => {
    return await runUpdateSchedule({
      workspaceID,
      updatedBy,
      cron,
      timezone,
      accountID,
      userID,
      applications,
    });
  };

  return {
    createSchedule,
    deleteSchedule,
    updateSchedule,

    createScheduleResponse,
    updateScheduleResponse,
    deleteScheduleResponse,

    wasCreatingScheduleSuccessful: createScheduleResponse.isSuccess,
    isScheduleCreationLoading: createScheduleResponse.isLoading,
    isScheduleCreationError: createScheduleResponse.isError,
    isDeleteScheduleSuccessful: deleteScheduleResponse.isSuccess,
    isDeleteScheduleLoading: deleteScheduleResponse.isLoading,
    isDeleteScheduleError: deleteScheduleResponse.isError,
    isUpdateScheduleSuccessful: updateScheduleResponse.isSuccess,
    isUpdateScheduleLoading: updateScheduleResponse.isLoading,
    isUpdateScheduleError: updateScheduleResponse.isError,
  };
};
